<template>
    <UiModal
        v-if="!isMobile"
        :isOpen="isOpen"
        @close="handleClose"
        title="All filters"
    >
        <template #content>
            <div class="space-y-6">
                <!-- User filter section -->
                <section v-if="users.length > 0" class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        User
                    </h3>
                    <div class="py-2">
                        <label
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="user in walletUsersAndEntities"
                            :key="user.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isUserSelected(user)"
                                @change="toggleUserSelection(user)"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ formatEntityName(user.name) }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />
                <!-- Account type filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        Account type
                    </h3>
                    <div class="py-2">
                        <label
                            v-for="accountType in accountTypes"
                            :key="accountType.id"
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isAccountTypeSelected(accountType)"
                                @change="
                                    toggleAccountTypeSelection(accountType)
                                "
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ accountType.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />
                <!-- Bank filter section -->
                <section class="w-full" v-if="walletBanks.length > 0">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        Bank
                    </h3>
                    <div class="py-2">
                        <label
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="bank in walletBanks"
                            :key="bank.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isBankSelected(bank)"
                                @change="toggleBankSelection(bank)"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ bank.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />
                <!-- Card type filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        Card type
                    </h3>
                    <div class="py-2">
                        <label
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="cardType in cardTypes"
                            :key="cardType.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isCardTypeSelected(cardType)"
                                @change="toggleCardTypeSelection(cardType)"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ $filters.titleCase(cardType.name) }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />

                <!-- Status filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        Status
                    </h3>
                    <div class="py-2">
                        <label
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="status in statuses"
                            :key="status.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isStatusSelected(status)"
                                @change="toggleStatusSelection(status)"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>
                <!--
                <hr class="border-slate-200 dark:border-slate-700" />

                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        Welcome bonus
                    </h3>
                    <div class="py-2">
                        <label
                            v-for="status in welcomeBonusStatuses"
                            :key="status.id"
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isWelcomeBonusStatusSelected(status)"
                                @change="
                                    toggleWelcomeBonusStatusSelection(status)
                                "
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />


                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        Bonus offers
                    </h3>
                    <div class="py-2">
                        <label
                            v-for="status in bonusOfferStatuses"
                            :key="status.id"
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isBonusOfferStatusSelected(status)"
                                @change="
                                    toggleBonusOfferStatusSelection(status)
                                "
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />


                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100 mb-4">
                        5/24
                    </h3>
                    <div class="py-2">
                        <label
                            v-for="status in fiveTwentyFourStatuses"
                            :key="status.id"
                            class="w-full p-2 text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="
                                    isFiveTwentyFourStatusSelected(status)
                                "
                                @change="
                                    toggleFiveTwentyFourStatusSelection(status)
                                "
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>
            --></div>
        </template>
        <template #footer>
            <div class="flex justify-between py-4 border-t border-slate-200 dark:border-slate-700">
                <button
                    class="btn-base btn-white"
                    @click="clearAllFilters"
                    :disabled="!hasActiveFilters"
                >
                    Clear all
                </button>
                <button class="btn-base btn-dark" @click="applyFilters">
                    Apply filters
                </button>
            </div>
        </template>
    </UiModal>
    <UiModalMobile v-else :isOpen="isOpen" @close="handleClose" title="Filters">
        <template #content>
            <div class="space-y-6">
                <!-- User filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">User</h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="user in walletUsersAndEntities"
                            :key="user.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isUserSelected(user)"
                                @change="toggleUserSelection(user)"
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ formatEntityName(user.name) }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />
                <!-- Account type filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Account type
                    </h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            v-for="accountType in accountTypes"
                            :key="accountType.id"
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isAccountTypeSelected(accountType)"
                                @change="
                                    toggleAccountTypeSelection(accountType)
                                "
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ accountType.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />
                <!-- Bank filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">Bank</h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="bank in walletBanks"
                            :key="bank.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isBankSelected(bank)"
                                @change="toggleBankSelection(bank)"
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ bank.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />
                <!-- Card type filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Card type
                    </h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="cardType in cardTypes"
                            :key="cardType.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isCardTypeSelected(cardType)"
                                @change="toggleCardTypeSelection(cardType)"
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ $filters.titleCase(cardType.name) }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />

                <!-- Status filter section -->
                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">Status</h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                            v-for="status in statuses"
                            :key="status.id"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isStatusSelected(status)"
                                @change="toggleStatusSelection(status)"
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <!--
                <hr class="border-slate-200 dark:border-slate-700" />

                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Welcome bonus
                    </h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            v-for="status in welcomeBonusStatuses"
                            :key="status.id"
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isWelcomeBonusStatusSelected(status)"
                                @change="
                                    toggleWelcomeBonusStatusSelection(status)
                                "
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>
            -->

                <!--
                <hr class="border-slate-200 dark:border-slate-700" />


                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Bonus offers
                    </h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            v-for="status in bonusOfferStatuses"
                            :key="status.id"
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="isBonusOfferStatusSelected(status)"
                                @change="
                                    toggleBonusOfferStatusSelection(status)
                                "
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>

                <hr class="border-slate-200 dark:border-slate-700" />

                <section class="w-full">
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">5/24</h3>
                    <div class="pt-6 pb-2 space-y-6">
                        <label
                            v-for="status in fiveTwentyFourStatuses"
                            :key="status.id"
                            class="w-full text-sm rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                :checked="
                                    isFiveTwentyFourStatusSelected(status)
                                "
                                @change="
                                    toggleFiveTwentyFourStatusSelection(status)
                                "
                            />
                            <span class="text-base text-slate-800 dark:text-slate-100">
                                {{ status.name }}
                            </span>
                        </label>
                    </div>
                </section>
            --></div>
        </template>
        <template #footer>
            <div class="px-6 py-1 pb-8 bg-white dark:bg-slate-800 flex gap-2">
                <button
                    class="w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-300 text-slate-800 dark:text-slate-100 rounded shadow text-sm font-medium hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2"
                    @click="clearAllFilters"
                    :disabled="!hasActiveFilters"
                >
                    Clear all
                </button>
                <button
                    class="w-full px-4 py-2.5 bg-slate-900 text-white rounded shadow text-sm font-medium hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2"
                    @click="applyFilters"
                >
                    Apply
                </button>
            </div>
        </template>
    </UiModalMobile>
</template>

<script setup>
import { watch } from 'vue';
import { computed, ref } from 'vue';
import { useWalletStore } from '@/store/wallet';
import { storeToRefs } from 'pinia';
import { useIsMobile } from '@/composables/useIsMobile';
import { formatEntityName } from '@/utils/entityNameFormatter.js';
import UiModal from '@/components/ui/modal/ui-modal.vue';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';

const walletStore = useWalletStore();
const { isMobile } = useIsMobile();

const {
    users,
    walletUsersAndEntities,
    walletBanks,
    cardTypes,
    statuses,
    selectedAccountTypes,
    selectedUsersOrEntities,
    selectedBanks,
    selectedCardTypes,
    selectedStatuses,
    selectedWelcomeBonusStatuses,
    selectedBonusOfferStatuses,
    selectedFiveTwentyFourStatuses,
} = storeToRefs(walletStore);

const localSelectedUsersOrEntities = ref([]);
const localSelectedBanks = ref([]);
const localSelectedCardTypes = ref([]);
const localSelectedStatuses = ref([]);
const localSelectedAccountTypes = ref([]);
const localSelectedWelcomeBonusStatuses = ref([]);
const localSelectedBonusOfferStatuses = ref([]);
const localSelectedFiveTwentyFourStatuses = ref([]);

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);

const handleClose = () => {
    emit('close');
};

watch(
    () => props.isOpen,
    (newValue) => {
        if (newValue) {
            initLocalFilters();
        }
    },
    { immediate: true }
);

const initLocalFilters = () => {
    localSelectedUsersOrEntities.value = selectedUsersOrEntities.value.map(
        (item) => ({
            ...item,
        })
    );
    localSelectedBanks.value = selectedBanks.value.map((item) => ({
        ...item,
    }));
    localSelectedCardTypes.value = selectedCardTypes.value.map((item) => ({
        ...item,
    }));
    localSelectedStatuses.value = selectedStatuses.value.map((item) => ({
        ...item,
    }));
    localSelectedAccountTypes.value = [...selectedAccountTypes.value];
    localSelectedWelcomeBonusStatuses.value =
        selectedWelcomeBonusStatuses.value.map((item) => ({ ...item }));
    localSelectedBonusOfferStatuses.value =
        selectedBonusOfferStatuses.value.map((item) => ({ ...item }));
    localSelectedFiveTwentyFourStatuses.value =
        selectedFiveTwentyFourStatuses.value.map((item) => ({ ...item }));
};

const applyFilters = () => {
    walletStore.clearAllFilters();

    localSelectedUsersOrEntities.value.forEach((userOrEntity) => {
        walletStore.toggleUserSelection(userOrEntity);
    });

    localSelectedBanks.value.forEach((bank) => {
        walletStore.toggleBankSelection(bank);
    });

    localSelectedCardTypes.value.forEach((cardType) => {
        walletStore.toggleCardTypeSelection(cardType);
    });

    localSelectedStatuses.value.forEach((status) => {
        walletStore.toggleStatusSelection(status);
    });

    localSelectedAccountTypes.value.forEach((type) => {
        walletStore.toggleAccountTypeSelection(type);
    });

    localSelectedWelcomeBonusStatuses.value.forEach((status) => {
        walletStore.toggleWelcomeBonusStatusSelection(status);
    });

    localSelectedBonusOfferStatuses.value.forEach((status) => {
        walletStore.toggleBonusOfferStatusSelection(status);
    });

    localSelectedFiveTwentyFourStatuses.value.forEach((status) => {
        walletStore.toggleFiveTwentyFourStatusSelection(status);
    });

    emit('close');
};

const hasActiveFilters = computed(() => {
    return (
        localSelectedUsersOrEntities.value.length > 0 ||
        localSelectedBanks.value.length > 0 ||
        localSelectedCardTypes.value.length > 0 ||
        localSelectedStatuses.value.length > 0 ||
        localSelectedAccountTypes.value.length > 0 ||
        localSelectedWelcomeBonusStatuses.value.length > 0 ||
        localSelectedBonusOfferStatuses.value.length > 0 ||
        localSelectedFiveTwentyFourStatuses.value.length > 0
    );
});

const fiveTwentyFourStatuses = [
    {
        id: 'under',
        name: 'Under 5/24',
    },
    {
        id: 'over',
        name: 'Over 5/24',
    },
];

const welcomeBonusStatuses = [
    {
        id: 'received',
        name: 'All received',
    },
    {
        id: 'not_received',
        name: 'Not received',
    },
];

const bonusOfferStatuses = [
    {
        id: 'all_received',
        name: 'All received',
    },
    {
        id: 'partially_received',
        name: 'Partially received',
    },
    {
        id: 'not_received',
        name: 'Not received',
    },
];

const accountTypes = [
    {
        id: 'cardholder',
        name: 'Cardholder',
    },
    {
        id: 'authorized_user',
        name: 'Authorized user',
    },
];

const isFiveTwentyFourStatusSelected = (status) => {
    return localSelectedFiveTwentyFourStatuses.value.some(
        (s) => s.id === status.id
    );
};

const isWelcomeBonusStatusSelected = (status) => {
    return localSelectedWelcomeBonusStatuses.value.some(
        (s) => s.id === status.id
    );
};

const isBonusOfferStatusSelected = (status) => {
    return localSelectedBonusOfferStatuses.value.some(
        (s) => s.id === status.id
    );
};

const clearAllFilters = () => {
    localSelectedUsersOrEntities.value = [];
    localSelectedBanks.value = [];
    localSelectedCardTypes.value = [];
    localSelectedStatuses.value = [];
    localSelectedAccountTypes.value = [];
    localSelectedWelcomeBonusStatuses.value = [];
    localSelectedBonusOfferStatuses.value = [];
    localSelectedFiveTwentyFourStatuses.value = [];
};

const isUserSelected = (user) => {
    return localSelectedUsersOrEntities.value.some((u) => u.id === user.id);
};

const isBankSelected = (bank) => {
    return localSelectedBanks.value.some((b) => b.id === bank.id);
};

const isCardTypeSelected = (cardType) => {
    return localSelectedCardTypes.value.some((c) => c.id === cardType.id);
};

const isStatusSelected = (status) => {
    return localSelectedStatuses.value.some((s) => s.id === status.id);
};

const isAccountTypeSelected = (type) => {
    return localSelectedAccountTypes.value.some((s) => s.id === type.id);
};

const toggleWelcomeBonusStatusSelection = (status) => {
    const index = localSelectedWelcomeBonusStatuses.value.findIndex(
        (s) => s.id === status.id
    );
    if (index > -1) {
        localSelectedWelcomeBonusStatuses.value.splice(index, 1);
    } else {
        localSelectedWelcomeBonusStatuses.value.push(status);
    }
};

const toggleBonusOfferStatusSelection = (status) => {
    const index = localSelectedBonusOfferStatuses.value.findIndex(
        (s) => s.id === status.id
    );
    if (index > -1) {
        localSelectedBonusOfferStatuses.value.splice(index, 1);
    } else {
        localSelectedBonusOfferStatuses.value.push(status);
    }
};

const toggleFiveTwentyFourStatusSelection = (status) => {
    const index = localSelectedFiveTwentyFourStatuses.value.findIndex(
        (s) => s.id === status.id
    );
    if (index > -1) {
        localSelectedFiveTwentyFourStatuses.value.splice(index, 1);
    } else {
        localSelectedFiveTwentyFourStatuses.value.push(status);
    }
};

const toggleAccountTypeSelection = (type) => {
    const index = localSelectedAccountTypes.value.findIndex(
        (s) => s.id === type.id
    );
    if (index > -1) {
        localSelectedAccountTypes.value.splice(index, 1);
    } else {
        localSelectedAccountTypes.value.push(type);
    }
};

const toggleUserSelection = (user) => {
    const index = localSelectedUsersOrEntities.value.findIndex(
        (u) => u.id === user.id
    );
    if (index > -1) {
        localSelectedUsersOrEntities.value.splice(index, 1);
    } else {
        localSelectedUsersOrEntities.value.push(user);
    }
};

const toggleBankSelection = (bank) => {
    const index = localSelectedBanks.value.findIndex((b) => b.id === bank.id);
    if (index > -1) {
        localSelectedBanks.value.splice(index, 1);
    } else {
        localSelectedBanks.value.push(bank);
    }
};

const toggleCardTypeSelection = (cardType) => {
    const index = localSelectedCardTypes.value.findIndex(
        (c) => c.id === cardType.id
    );
    if (index > -1) {
        localSelectedCardTypes.value.splice(index, 1);
    } else {
        localSelectedCardTypes.value.push(cardType);
    }
};

const toggleStatusSelection = (status) => {
    const index = localSelectedStatuses.value.findIndex(
        (s) => s.id === status.id
    );
    if (index > -1) {
        localSelectedStatuses.value.splice(index, 1);
    } else {
        localSelectedStatuses.value.push(status);
    }
};
</script>
